(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["D4-Comparison-with-text"] && !Shopify.designMode) return;
  try {
    
  // const arrowButtons = document.querySelectorAll('.D4-comparison-with-text-main-div .arrow-parent button')
  // let button, hazar;

  // for (let i = 0; i < arrowButtons.length; i++) {
  //   button = arrowButtons[i];

  //   button.addEventListener('click', (e)=>{
  //     if (e.target.id == "btnPrev") {
  //       document.querySelector('.D4-comparison-with-text-main-div .table-parent').scrollBy({
  //         left: -1000, // Adjust the value to scroll by the desired amount
  //         behavior: 'smooth' // For smooth scrolling
  //       });

  //       hazar = "hazar"
  //     } else {
  //       document.querySelector('.D4-comparison-with-text-main-div .table-parent').scrollBy({
  //         left: 1000, // Adjust the value to scroll by the desired amount
  //         behavior: 'smooth' // For smooth scrolling
  //       });

  //       hazar = "nothazar"
  //     }

  //     if (hazar == "hazar") {
  //       arrowButtons[0].querySelector('svg').style.fillOpacity = "0.25"
  //       arrowButtons[1].querySelector('svg').style.fillOpacity = "1"
  //     } else {
  //       arrowButtons[0].querySelector('svg').style.fillOpacity = "1"
  //       arrowButtons[1].querySelector('svg').style.fillOpacity = "0.25"
  //     }
  //   })
  // }


  // new code
  const arrowButtons = document.querySelectorAll('.D4-comparison-with-text-main-div .arrow-parent button');
let button, hazar;

for (let i = 0; i < arrowButtons.length; i++) {
  button = arrowButtons[i];

  button.addEventListener('click', (e) => {
    const tableParent = document.querySelector('.D4-comparison-with-text-main-div .table-parent');
    const maxScrollLeft = tableParent.scrollWidth - tableParent.clientWidth; // Maximum scrollable distance
    const currentScrollLeft = tableParent.scrollLeft; // Current scroll position

    if (e.target.id == "btnPrev") {
      const scrollAmount = Math.min(currentScrollLeft, 1000); // Scroll by 1000 or remaining scroll distance
      tableParent.scrollBy({
        left: -scrollAmount,
        behavior: 'smooth' // For smooth scrolling
      });
      hazar = "hazar";
    } else {
      const scrollAmount = Math.min(maxScrollLeft - currentScrollLeft, 1000); // Scroll by 1000 or remaining scroll distance
      tableParent.scrollBy({
        left: scrollAmount,
        behavior: 'smooth' // For smooth scrolling
      });
      hazar = "nothazar";
    }

    // Update arrow button styles
    if (hazar == "hazar") {
      arrowButtons[0].querySelector('svg').style.fillOpacity = "0.25";
      arrowButtons[1].querySelector('svg').style.fillOpacity = "1";
    } else {
      arrowButtons[0].querySelector('svg').style.fillOpacity = "1";
      arrowButtons[1].querySelector('svg').style.fillOpacity = "0.25";
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["D4-Video-Section"] && !Shopify.designMode) return;
  try {
    
// const observer = new IntersectionObserver((entries, observer) => {
//   entries.forEach(entry => {
//     if (entry.isIntersecting) {
//       const video = entry.target.querySelector("video");
//       try {
//         if (video.paused == true) {
//           video.muted = true;
//           video.play();
//         }
//       } catch (error) {
//         console.log(error)
//       }
//       observer.unobserve(entry.target);
//     }
//   });
// }, { threshold: 0.1 }); // Adjust threshold as needed

function handleScroll() {
  const videoSections = document.querySelectorAll('.D4-Video-section-parent');

  videoSections.forEach((videoSection) => {
    // observer.observe(videoSection);
    let initialScrollY;
    let initialScroll = true;
    let sectionTopp = false;
    window.addEventListener('scroll', ()=>{
      if (window.innerWidth > 600) {
        
        const textSection = videoSection.querySelector('.D4-Video-section-child2');
        const videoSectionRect = videoSection.getBoundingClientRect();
        const sectionTop = videoSectionRect.top;
        const sectionBottom = videoSectionRect.bottom;
      
        if (sectionTop >= 0 && sectionTop <= 50) {
          sectionTopp = true;
        }
      
        if (sectionTopp && sectionBottom > 0) {
          if (initialScroll == true) {
            initialScrollY = window.scrollY;
            initialScroll = false;
          }
          const scrollY = window.scrollY - initialScrollY;
          const newTop = scrollY;          
          textSection.style.position = 'fixed';    
          if(newTop < 0){
            textSection.style.top = `0px`;
          }else{
          textSection.style.top = `${newTop}px`;   
          }       
        }      
        if (sectionTop >= 0) {
          textSection.style.position = 'fixed';
          //textSection.style.top = `80px`;
        }
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", handleScroll)  
  
 // d11 above code for animation
  // const playButtons = document.getElementsByClassName('D4-Video-section-play-button');
  // const videos = document.getElementsByClassName('D4-Video-section-video');
  // // const overlay = document.getElementsByClassName('d7-custom-overlay-video');
  // const allMuteBtnsCustom = document.getElementsByClassName('d7-custom-mute-unmute');

  // for (let i = 0; i < playButtons.length; i++) {
  //     let isPlaying = false;

  //   allMuteBtnsCustom[i].addEventListener('click', ()=>{
  //     if (videos[i].muted == true) {
  //       videos[i].muted = false
  //       allMuteBtnsCustom[i].querySelector('.icon-mute').style.display = "none"
  //       allMuteBtnsCustom[i].querySelector('.icon-unmute').style.display = "block"
  //     } else {
  //       videos[i].muted = true
  //       allMuteBtnsCustom[i].querySelector('.icon-mute').style.display = "block"
  //       allMuteBtnsCustom[i].querySelector('.icon-unmute').style.display = "none"
  //     }
  //   })

  //     playButtons[i].addEventListener('click', () => {
  //         if (isPlaying) {
  //             videos[i].pause();
  //             // overlay[i].style.display = "block";
  //         } else {
  //             videos[i].play();
  //             // overlay[i].style.display = "none";
  //         }
  //     });

  //     videos[i].addEventListener('click', () => {
  //         if (isPlaying) {
  //             videos[i].pause();
  //             // overlay[i].style.display = "block";
  //         } else {
  //             videos[i].play();
  //             // overlay[i].style.display = "none";
  //         }
  //     });

  //     videos[i].addEventListener('play', () => {
  //         playButtons[i].style.display = "none";
  //         isPlaying = true;
  //         // overlay[i].style.display = "none";
  //     });

  //     videos[i].addEventListener('pause', () => {
  //         playButtons[i].style.display = "block";
  //         isPlaying = false;
  //         // overlay[i].style.display = "block";
  //     });

  //     videos[i].addEventListener('ended', () => {
  //         playButtons[i].style.display = "block";
  //         isPlaying = false;
  //         // overlay[i].style.display = "block";
  //     });

    
  // }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-footer"] && !Shopify.designMode) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();
})();
